'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Checkbox/Checkbox.tsx
import { twMerge } from "tailwind-merge";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { StrokeCheckIcon } from "@wbk/svg";
import { jsx, jsxs } from "react/jsx-runtime";
var THEME_CLASSES = {
  primary: "focus:ring-primary text-primary-contrast data-[state=checked]:bg-primary group-hover:ring-primary",
  secondary: "focus:ring-secondary text-secondary-contrast data-[state=checked]:bg-secondary group-hover:ring-secondary",
  tertiary: "focus:ring-tertiary text-tertiary-contrast data-[state=checked]:bg-tertiary group-hover:ring-tertiary",
  action: "focus:ring-action text-action-contrast data-[state=checked]:bg-action group-hover:ring-action",
  error: "focus:ring-error text-error-contrast data-[state=checked]:bg-error group-hover:ring-error",
  success: "focus:ring-success text-success-contrast data-[state=checked]:bg-success group-hover:ring-success",
  white: "focus:ring-dark text-dark-contrast data-[state=checked]:bg-dark group-hover:ring-dark",
  black: "focus:ring-light text-light-contrast data-[state=checked]:bg-light group-hover:ring-light",
  transparent: "focus:ring-transparent text-transparent group-hover:ring-transparent"
};
var Checkbox = (_a) => {
  var _b = _a, {
    label,
    error,
    onChange,
    groupClassName,
    theme = "primary",
    hideErrorSpace = true,
    rounded = true,
    ref
  } = _b, props = __objRest(_b, [
    "label",
    "error",
    "onChange",
    "groupClassName",
    "theme",
    "hideErrorSpace",
    "rounded",
    "ref"
  ]);
  const showError = typeof error === "string" && !!error || !hideErrorSpace;
  return /* @__PURE__ */ jsxs("div", { className: groupClassName, ref, tabIndex: -1, children: [
    /* @__PURE__ */ jsxs(
      "label",
      {
        className: twMerge(
          "group flex cursor-pointer items-start gap-2 has-[input:disabled]:cursor-not-allowed",
          error && "text-error"
        ),
        children: [
          /* @__PURE__ */ jsx(
            CheckboxPrimitive.Root,
            __spreadProps(__spreadValues({
              onCheckedChange: (value) => {
                onChange == null ? void 0 : onChange(!!value, (props == null ? void 0 : props.name) || "");
              }
            }, props), {
              className: twMerge(
                "bg-body !ring-offset-body border-input-border mt-[3px] inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center border focus:ring-1 disabled:cursor-not-allowed disabled:opacity-50",
                "focus:ring-offset-1 group-hover:ring-1 group-hover:ring-offset-1",
                THEME_CLASSES[theme] || "",
                rounded ? "rounded-sm" : "",
                props.className || ""
              ),
              children: /* @__PURE__ */ jsx(CheckboxPrimitive.Indicator, { children: /* @__PURE__ */ jsx(StrokeCheckIcon, { className: "w-3" }) })
            })
          ),
          label
        ]
      }
    ),
    showError && /* @__PURE__ */ jsx(
      "p",
      {
        className: `text-error my-1 min-h-[16px] text-xs ${error ? "visible" : "text-transparent"}`,
        children: error
      }
    )
  ] });
};
var Checkbox_default = Checkbox;

export {
  Checkbox_default
};
//# sourceMappingURL=chunk-TEDXYJJL.mjs.map